import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Button, { ButtonTypes } from 'components/common/button';
import InternetIcon from 'components/common/icons/stroke/internet-stroke';
import Notification from './notification';

const StyledMessage = styled.div`
  align-items: center;
  color: black;
  display: flex;
  font-weight: 600;
`;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledInternetIcon = styled(InternetIcon)`
  margin-right: 16px;
  width: 16px;
`;

const HelpLink = styled.a`
  color: ${p => p.theme.colors.black};
  padding-left: 3px;
  text-decoration: underline;
`;

const DisconnectedNotification = ({ id, onDismiss }) => {
  const { t } = useTranslation();
  return (
    <Notification contentClasses="warningNotification" notificationId={id} onClick={onDismiss}>
      <StyledContent>
        <StyledMessage>
          <StyledInternetIcon />
          <Trans i18nKey="Your internet connection is unstable and Gladly may not work as expected. To troubleshoot, visit our <helpLink>Help Docs</helpLink>.">
            Your internet connection is unstable and Gladly may not work as expected. To troubleshoot, visit our
            <HelpLink
              href="https://help.gladly.com/docs/en/unstable-internet-connection"
              rel="noopener noreferrer"
              target="_blank"
            >
              Help Docs
            </HelpLink>
            .
          </Trans>
        </StyledMessage>
        <Button buttonType={ButtonTypes.SECONDARY} contrast onClick={onDismiss}>
          {t('Dismiss')}
        </Button>
      </StyledContent>
    </Notification>
  );
};

export default DisconnectedNotification;
